import axios from 'axios';
import { getTokenCredentials } from '../../../Shared/functions';
import { BASE_API } from '../../../Shared/Constants';

export function getAllLists(body){
    return axios.post(BASE_API + 'api/home', body , {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic '+getTokenCredentials()
        }
    })
    .then(response => {return response})
    .catch(error => {
        return null
    });
}

export function getAllPayments(){
    return axios.post(BASE_API + 'api/grandtotalpayment', null, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic '+getTokenCredentials()
        }
    })
    .then((response)=> {return response})
    .catch(error => {
        return error
    })
}
